export default __webpack_public_path__ + "media/music/ba7b20d2f6d0e15a40c4fe52d089a575.mp3";